angular.module('unica_campaign.campaign_services')

.factory('CampaignAssignService', function($http, getBaseApiURL) {

	var campaignAssignService = {};

	campaignAssignService.assign = function( eventId, campaignId, invitationsData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/assign/' + eventId + '/' + campaignId ,
			data: {
				invitations: invitationsData
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_emails;
			}

		});
	};

	campaignAssignService.list = function (eventId, campaignId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/assign-list/' + eventId + '/' + campaignId ,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_emails;
			}

		});
	};

	campaignAssignService.delete = function (campaignEmailId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/campaign/assign-delete/' + campaignEmailId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return campaignAssignService;

});